import React, { useEffect } from 'react';

const ScriptInjector = ({ code }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = code;
    
    script.innerHTML = `
    ${code}
    var ev = new Event('DCBProtectRun');
    document.dispatchEvent(ev);
  `;

   document.body.appendChild(script);

    // const ev = new Event('DCBProtectRun');
    // document.dispatchEvent(ev);

    // Cleanup function to remove the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, [code]);

  return null;
};

export default ScriptInjector;
